import React from 'react'
import { Skeleton} from 'antd'
import styles from './SkeletonCardBanner.module.scss'
const SkeletonCardBanner = () => {
  return(
    <div className = {styles.rootSket}>
      <Skeleton active />
      <Skeleton active />
    </div>
  )
}
export default SkeletonCardBanner